<template>
  <div class="table" ref="tableRef">
    <artmisads-table :columns="columns" row-key="id" :data-source="props.dataList" :pagination="{
      total: props.listTotal,
      current: props.params.page,
      pageSize: props.params.size,
      showSizeChanger: true
    }" :change="onChangePage" tableLayout="fixed" :scroll="{ x: 1800, y: tableScrollHeight }">
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.name === 'showCurrency'">
          {{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ text }}
        </template>
        <template v-if="column.name === 'amount'">
          <div v-if="record.billingType == 'MONTHLY'">
            {{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ text }}
          </div>

          <div v-else :class="text ? text > 0 ? 'amount-plus' : 'amount-minus' : ''">
            {{ setUnit(text) }} {{ text ? AMAZON_CURRENCY_MAPPER[record.marketplace] : '' }}{{ setAmount(text) }}
          </div>

        </template>
        <template v-if="column.name === 'commissionAmount'">
          <div v-if="record.billingType == 'MONTHLY'">
            {{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ text }}
          </div>
          <div v-else-if="record.billingType == 'MANUAL'">
            --
          </div>
          <div v-else :class="text ? text > 0 ? 'amount-plus' : 'amount-minus' : ''">
            {{ setUnit(text) }} {{ text ? AMAZON_CURRENCY_MAPPER[record.marketplace] : '' }}{{ setAmount(text) }}
          </div>

        </template>
        <template v-if="column.dataIndex === 'paidAmount' && record.billingType == 'MONTHLY'">
          <div class="paid-amount"
            v-if="record.paidAmount > 0 && record.paidAmount < record.amount && (record.paidAmount / record.amount).toFixed(2) < 0.97">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            <span>{{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ record.paidAmount }}</span>
          </div>
          <span v-else>{{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ record.paidAmount }}</span>
        </template>
        <template v-if="column.dataIndex === 'paidAmount' && record.billingType !== 'MONTHLY'">
          <div :class="text ? text > 0 ? 'amount-plus' : 'amount-minus' : ''">
            {{ setUnit(text) }} {{ text || text == 0 ? AMAZON_CURRENCY_MAPPER[record.marketplace] : '' }}{{ setAmount(text) }}
          </div>
        </template>
        <template v-if="column.name === 'sellerName'">
          <div class="seller-name">
            <span>{{ record.sellerName }}</span>
            <span>{{ record.sellerEmail }}</span>
          </div>
        </template>
        <template v-if="column.name === 'status'">
          <div v-if="record.billingType === 'MONTHLY'">
            {{ FINANCE_PAYMENT_DETAIL_STATUS_MAP[text]?.label }}
          </div>
          <div v-else>
            {{ record.displayStatus }}
          </div>
        </template>
        <template v-if="column.name === 'brands'">
          <span class="brands-name">
            {{ record?.brands ? record?.brands?.replaceAll(',', ', ') : '--' }}
          </span>
        </template>
        <template v-if="column.name === 'date'">
          <div v-if="record.receivedPaymentList.length === 0">
            {{ record.bankReceivedTime  }}
          </div>
          <div v-else ref="content">
            <a-popover trigger="click"  :getPopupContainer="() => $refs.content">
    <template #content>
      <div v-for="item in record.receivedPaymentList" :key="item.id" class="received-item">
         <span>{{ item.receivedDate? item?.receivedDate?.replaceAll('-', '/') : '--' }}</span> 
         <span>{{ AMAZON_CURRENCY_MAPPER[record.marketplace] }} {{ item.receivedAmount }}</span> 
      </div>
    
    </template>
     <a style="color: #1890FF;text-decoration: underline;" >
          view More
      </a>
  </a-popover>
           
          </div>
        </template>
        <!-- commissionAmount
platformFeeAmount -->
        <!-- <template v-if="column.dataIndex === 'commissionAmount'">
          <span class="commission-amount">
         
            {{record.billingType == 'MANUAL'? '--' : record?.commissionAmount}}
          </span>
        </template> -->
        <template v-if="column.name === 'actions'">
          <div class="actions">
            <artmisads-select-button v-if="record.status !== 'paid_review' && record.status !== 'paid'" size="small"
              @click="addReceived(record)">Edit</artmisads-select-button>
            <!-- <artmisads-select-button  @click="() => setShowPaymentModal(true, false, record.billingId)" size="small">Review</artmisads-select-button> -->
            <artmisads-select-button v-if="record.status === 'paid_review'"
              @click="() => setShowPaymentModal(true, false, record.billingId)"
              size="small">Review</artmisads-select-button>
            <artmisads-select-button @click="() => toInvoicePdf(record.billingId)"
              size="small">Invoice</artmisads-select-button>
            <a-popconfirm title="Are you sure to send email to seller?" ok-text="Yes" cancel-text="No" class=""
              @confirm="() => props.postEmail(record.billingId)" :getPopupContainer="() => tableRef">
              <artmisads-select-button size="small">Email</artmisads-select-button>
            </a-popconfirm>
            <artmisads-select-button
              @click="() => setShowPaymentDetailModal(true, record.billingId, record.billingType)"
              size="small">Details</artmisads-select-button>
            <!-- <artmisads-select-button @click="() => showSellerDetail(record.billingId)" size="small">Data</artmisads-select-button> -->
          </div>
        </template>
      </template>
    </artmisads-table>
    <EditReceiveRecordModal ref="editReceiveRecordModalRef" @refresh="refreshList" />
  </div>
</template>
<script lang="jsx" setup>
import { useRouter } from "vue-router"
import moment from 'moment'
import { ref, computed } from 'vue'
import { message } from "ant-design-vue"
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'
import { FINANCE_PAYMENT_DETAIL_STATUS_MAP } from '~/contants/operator'
import { useTableScrollHeight } from "@/utils/useTableScrollHeight"
import EditReceiveRecordModal from './editReceiveRecordModal.vue'
const router = useRouter()
const tableRef = ref(null)
const editReceiveRecordModalRef = ref(null)
const props = defineProps(['setShowPaymentModal', 'setShowPaymentDetailModal', 'listTotal', 'setParams', 'params', 'dataList', 'getList', 'status', 'postEmail'])
const setBillingType = (value) => {
  if (value === undefined || value === null) return ''
  const str = String(value).toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}
const columns = computed(() => {
  return props.status === 'pending' ?
    [
      {
        title: 'Payment ID',
        dataIndex: 'billingId',
        width: 140,
      },
      {
        title: 'ArtemisAds Account',
        dataIndex: 'sellerName',
        width: 120,
        name: 'sellerName',
      },
      {
        title: 'Brands Name',
        dataIndex: 'brands',
        name: 'brands',
        width: 150,
      },
      {
        title: 'BD',
        dataIndex: 'bd',
        name: 'bd',
        width: 120,
      },
      {
        title: 'Referral',
        dataIndex: 'referral',
        name: 'referral',
        width: 120,
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        width: 100,
        name: 'amount',
      },
      {
        title: 'Media Commission',
        dataIndex: 'commissionAmount',
        width: 160,
        name: 'commissionAmount',
      },
      {
        title: 'Platform Commission',
        dataIndex: 'platformFeeAmount',
        width: 160,
        name: 'commissionAmount',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        name: 'status',
        width: 140,
      },
    ] : [
      {
        title: 'Payment ID',
        dataIndex: 'billingId',
        width: 120,
      },
      {
        title: 'ArtemisAds Account',
        dataIndex: 'sellerName',
        width: 120,
        name: 'sellerName',
      },
      {
        title: 'Brands Name',
        dataIndex: 'brands',
        name: 'brands',
        width: 100,
      },
      {
        title: 'BD',
        dataIndex: 'bd',
        name: 'bd',
        width: 120,

      },
      {
        title: 'Referral',
        dataIndex: 'referral',
        name: 'referral',
        width: 120,

      },
      {
        title: 'Invoice No.',
        dataIndex: 'invoiceNo',
        width: 130,
      },
      {
        width: 120,
        title: 'Type',
        dataIndex: 'billingType',
        name: 'billingType',
        customRender: ({ text, record }) => {
          return setBillingType(record.billingType)
        }
      },

      {
        title: 'Amount',
        dataIndex: 'amount',
        width: 100,
        name: 'amount',
      },
      {
        title: 'Media Commission',
        dataIndex: 'commissionAmount',
        width: 160,
        name: 'commissionAmount',
      },
      {
        title: 'Platform Commission',
        dataIndex: 'platformFeeAmount',
        width: 160,
        name: 'commissionAmount',
      },
      {
        title: 'Paid',
        dataIndex: 'paidAmount',
        width: 100,

      },
      {
        title: 'Date',
        dataIndex: 'bankReceivedTime',
        width: 100,
        name: 'date',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        name: 'status',
        width: 100,
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        name: 'actions',
        fixed: 'right',
        width: 300,
      },
    ]
})
const setUnit = (record) => {
  if (record || record == 0) {
    if (record > 0) {
      return '+'
    }
    else if (record == 0) {
      return ''
    }
    else {
      return '-'
    }
  }
  else {
    return ''
  }
}
const setAmount = (record) => {
  if (record || record == 0) {
    return Math.abs(record)
  }
  else {
    return '--'
  }
}
const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  let newParams = { ...props.params }
  newParams.page = current
  newParams.size = pageSize
  if (sorter) {
    const { field, order } = sorter
    newParams.sortField = field
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc'
  } else {
    newParams.sortField = ''
    newParams.sortDirection = ''
  }
  props.setParams(newParams)
  props.getList()
}

const toDetail = id => {
  props.setBillingId(id)
}
const addReceived=(record)=>{
editReceiveRecordModalRef.value.openModal(record)
}
const toInvoicePdf = billingId => {
  const { href } = router.resolve({ path: `/operator/invoice-pdf/${billingId}` })
  window.open(href, '_blank')
}

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 250,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350
})
const refreshList=()=>{
  props.getList()
}
// setTimeout(()=>{
//   editReceiveRecordModalRef.value.openModal()
// },100)
</script>
<style lang="less" scoped>
.amount-plus {
  color: #FF0000;
}
.received-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 280px;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}
.amount-minus {
  color: #2AAE67;
}

.table {
  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-tooltip-arrow) {
    display: none;
  }

  :deep(.ant-table) {
    .ant-table-thead {
      .ant-table-cell {
        line-height: 24px;
      }
    }

    .seller-name {
      display: flex;
      flex-direction: column;

      >span {
        &:first-child {
          font-weight: 600;
          margin-bottom: 2px;
        }
      }
    }

    .brands-name {
      word-break: break-word;
    }

    .paid-amount {
      color: var(--red-1);
      display: flex;

      svg {
        align-self: center;
        margin-right: 4px;
      }
    }

    .actions {
      display: flex;

      button {
        align-self: center;
        margin-right: 10px;
      }

      .confirm-btn {
        color: var(--primary-text);
        border-color: #fff;
        box-shadow: none;
      }
    }
  }
}
</style>